import type { Config } from "../config.contract";
import { BaseEnvironment } from "./base.environment";

export class BlueEnvironment extends BaseEnvironment implements Config {
  /**
   * Webmotors base domain
   *
   */
  domain = "azulportal.webmotors.com.br";

  /**
   * Enable logging for BLUE Environment
   *
   */
  logging = true;

  /**
   * Webmotors api URL
   *
   */
  apiURL = `https://${this.domain}/api`;

  /**
   * Webmotors base URL
   *
   */
  baseURL = `https://${this.domain}`;

  /**
   * Webmotors private api URL
   *
   */
  apiPrivateURL =
    "https://yur5i9svf7-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/azl/api";

  /**
   * SEO private api URL
   *
   */
  seoApiPrivateURL =
    "https://sem3hlobfi-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/azl/api";

  /**
   * Cookie domain on BLUE environment
   *
   */
  cookieDomain = [this.domain, `.${this.domain}`, ".webmotors.com.br"];

  /**
   * Auth Cookie Name on blue environment
   *
   */
  authCookieName = "webmotors.jwt.token";

  /**
   * Access Token Cookie Name on blue environment
   *
   */
  accessTokenCookieName = "webmotors.access.token";

  /**
   * Refresh Token Cookie Name on blue environment
   *
   */
  refreshTokenCookieName = "webmotors.refresh.token";

  /**
   * Vehicle photo path on BLUE environment
   *
   */
  photoPath = "https://image.webmotors.com.br";

  /**
   * Webmotors chat api websocket URL
   *
   */
  chatApiUrl = "wss://chat.webmotors.com.br";

  /**
   * Adobe SDK path
   *
   */
  adobeSDK =
    "https://assets.adobedtm.com/0a9348ad03c2/c7e2a344c6e9/launch-7deede3856c6-staging.min.js";

  /**
   * Hot deal image path on BLUE environment
   *
   */
  hotDealImage = "https://image.webmotors.com.br/feiroes/imagens/prd/_portal/";

  /**
   * Data Dog Sample Config
   */
  traceSampleRate = 100;
  sessionSampleRate = 10;
  sessionReplaySampleRate = 10;

  /**
   * Seller shield image path
   */
  sellerShieldImage = "https://azulportal.webmotors.com.br/img/blindagem/";

  /**
   * Login route
   *
   */
  loginRoute = `https://${this.domain}/login`;
}
